import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { getArticles, getArticleCategories, getSearchList, getNormal } from '../../utils/requests';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const BreadcrumbBarCustom = dynamic(() => import('../../components/breadcrumbArticle'), {
  ssr: false,
});
import { Typography, Button } from '@mui/material';
import ArticleItem from '../../components/ArticleItem';

import {
  Row,
  Col,
  Tag,
  Input,
  Divider
} from 'antd';
import { LeaveYourRequirement } from '../../components/LeaveYourRequirement';
import { t } from 'i18next';
const DynamicPropertyItems = dynamic(() => import('../../components/PropertyItems'), {
  ssr: false
})
const localeLinkMapping = {
  en: '/All/Estate?endPrice=1000000000',
  cn: '/全部/地产?endPrice=1000000000',
  th: '/รวม/อสังหา?endPrice=1000000000', // Default or Thai locale
};

export const getDefaultPropertyLink = (locale = 'th') => {
  return localeLinkMapping[locale] || localeLinkMapping.th;
};

const Article = (props) => {
  const { t, ready } = useTranslation(['common', 'home',]);
  const { locale, propertyList } = props;
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(24);
  const [data, setData] = useState<Record<string, any>[]>([]);
  const [total, setTotal] = useState(1)
  const [categories, setCategories] = useState([])
  const [currentCategory, setCurrentCategory] = useState(null)

  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState<boolean>(false)
  const [linkAction, setLinkAction] = useState<string>('')

  /* -------------------------------------------------------------------------- */
  /*                                   Methods                                  */
  /* -------------------------------------------------------------------------- */

  const fetchArticle = async (reset=false) => {
    setLoading(true)
    const response = await getArticles(page, perPage, search || null, currentCategory)
    const resp = response.data;
    if(!reset){
       setData((prev) => [...prev, ...resp])    
    }else{
      setData(resp)
    }
   
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }

  const fetchArticleOnChangeCategory = async () => {
    setData([])
    setLoading(true)
    const response = await getArticles(page, perPage, search || null, currentCategory)
    setTotal(response.pagination.total)
    const resp = response.data;
    setData(resp)
    setPage(1)
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }

  const fetchCategory = async () => {
    const catData = await getArticleCategories(0, 1000)
    setCategories(catData.data)
  }

  const loadMore = async () => {
    setPage(prev => prev + 1)
  }

  const handleSearch = async () => {
    await fetchArticleOnChangeCategory()
  }

  /* -------------------------------------------------------------------------- */
  /*                                   Watches                                  */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    fetchArticle()
  }, [page])

  useEffect(() => {
    fetchArticleOnChangeCategory()
  }, [currentCategory])

  useEffect(() => {
    fetchCategory()
  }, [])

  useEffect(() => {
    setLinkAction(getDefaultPropertyLink(locale))
  },[locale])

  return (
    <>
      <Row style={{ paddingTop: "10px" }}>
        <Col span={24} style={{ marginBottom: 30 }}>
          {/* <Carousel autoPlay infiniteLoop showThumbs={false} interval={4000} centerMode centerSlidePercentage={60}>
            {banners?.length && banners.map((item) => {
                const { news_Images, news_ID } = item
               let imageUrl = undefined
               const defaultImage = '/assets/single-logo.png'
               if (news_Images) {
                  imageUrl = `https://cdn.9asset.com/download/article_image/${item.news_ID}/${item.news_Images}`
               } else {
                   imageUrl = defaultImage
               }

              return (
                <div className='mx-1' key={`${news_ID}`}>
                  <CardMedia
                    component="img"
                    sx={{ width: 'auto', maxWidth: '100%', maxHeight: '480px', objectFit: 'contain', margin: 'auto' }}
                    alt={news_ID}
                    image={imageUrl || ''}
                    onError={(e: any) => {
                      e.target.src = defaultImage;
                    }}
                  />
                </div>
              )
            })}
          </Carousel> */}
        </Col>
        <Col span={24} style={{ marginBottom: 50 }}>
          <Typography variant={'subtitle1'}>
           {t('news_category')} 
          </Typography>

          {categories && categories.length > 0 && categories?.map((item, index) => {
            if (currentCategory === item.category_ID) {
              return (
                <Tag style={{ borderRadius: '15px', cursor: 'pointer' }} key={`${item.category_ID}`} color="#f50" onClick={() => setCurrentCategory(item.category_ID)}>
                  {`${item[`category_Name_${locale.toUpperCase()}`]}`}
                </Tag>
              )
            } else {
              return (
                <Tag style={{ borderRadius: '15px', cursor: 'pointer' }} key={`${item.category_ID}`} color="volcano" onClick={() => setCurrentCategory(item.category_ID)}>
                  {`${item[`category_Name_${locale.toUpperCase()}`]}`}
                </Tag>
              )
            }

          })}
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={6} lg={6}>
          <BreadcrumbBarCustom breadcrumb={[
            { href: 'article', name: `${t('article')}` },
          ]} locale={locale} t={t} />
        </Col>
        <Col xs={24} md={6} lg={6}>
          <Input.Search 
            placeholder="input search " 
            enterButton="Search" 
            onSearch={()=>fetchArticle(true)}
            size="large"
            value={search}
            onChange={(e)=>setSearch(e.target.value)}
            allowClear
          />
        </Col>
      
      </Row>
      <Row >
        <Divider />
      </Row>
      <Row>
        <Col xs={24} sm={24} md={18} lg={18}>
          <Row gutter={[{ xs: 8, sm: 8, md: 8, lg: 8 }, { xs: 16, sm: 16, md: 16, lg: 16 }]}>
            {data?.map((item, index) => {
              return <ArticleItem item={item} locale={locale} key={index} />
            })}
          </Row>
          <Row>
            <Col span={24} style={{ margin: 20, textAlign: 'center', justifyContent: 'center' }}>
              {total > (( page) * perPage) && (
                <Button
                  variant="contained"
                  sx={{ backgroundColor: '#f4762a', color: 'white' }}
                  onClick={() => loadMore()}
                >
                  More
                </Button>
              )}

            </Col>
          </Row>
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} style={{paddingLeft:15, paddingRight:15}}>
          <LeaveYourRequirement t={t} />
          <Row>
            <Col span={24} style={{textAlign: 'center', justifyContent: 'center' }}>
              {propertyList && propertyList.data && propertyList.data.items && propertyList.data.items.length > 0 && propertyList.data.items.map((item, index) => {
                return (
                  <DynamicPropertyItems t={t}  d={item} locale={locale} key={index} linkAction={`${linkAction}`}/>
                )
              }
              )}

            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}
  const fetchProperty = async () => {
    try {
      const response = await getSearchList({
        startprice: 0,
        endprice: 1000000000,
        page: 1,
        limit: 4,
        locationtypeid: null,
        locationid: null,
        locationbranchid: null,
        propertystatus: true,
        offset: 0,
        es: true
      } as any)
      return response
    } catch (error) {
      console.error('Error fetching property list for article page:', error)
      return {
        data: {
          items: []
        }
      }
    }
  }
export const getStaticProps = async ({ locale }) => {
  const propertyList = await fetchProperty()

  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'th', ['common', 'home'])),
      locale,
      propertyList: propertyList || { data: { items: [] } },
    },
    revalidate: 10
  }
}

export default Article